module.exports = __webpack_public_path__ + "static/logo-cbm-9a2a9b2667a3e3d293b0eb40aa57e075.svg";